import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EyeVisionTypeModel } from '../PrimaryExaminationModels/eyevisiontypes.model';
import { EMRService } from '../EMR.service';
import { HelplistService } from 'app/helplist.service';

@Component({
  selector: 'app-eyecheck',
  templateUrl: './eyecheck.component.html',
  styleUrls: ['./eyecheck.component.scss']
})
export class EyecheckComponent implements OnInit {

  displayedColumns: string[] = ['popupDescription'];
  dataSource = new MatTableDataSource<EyeVisionTypeModel>();
  plusValues: any;
  minusValues: any;
  searchValue:any;

  applyFilter_grid(filterValue: string) {
    if(filterValue == ''){
      this.dataSource.data = this.helplistservice.eyevisiontypes_AXS.slice();
    }else{
      // this.dataSource.filter = filterValue.trim().toLowerCase();
      let filteredData = this.helplistservice.eyevisiontypes_AXS.filter(item => item.popupDescription == filterValue)
      this.dataSource = new MatTableDataSource(filteredData);
    }
  }

  set_opto_vison_values(row){
    switch (this.emrservice.ar_value_box) {
      case "r1c1": {
        this.emrservice.opto.dvunaidedOd = row.popupDescription;
        
            break;
      }
      case "r1c2": {
        this.emrservice.opto.dvunaidedOs = row.popupDescription;
        
            break;
      }
      case "r1c3": {
        this.emrservice.opto.nvunaidedOd = row.popupDescription;
        
            break;
      }
      case "r1c4": {
        this.emrservice.opto.nvunaidedOs = row.popupDescription;
        
            break;
      }
      case "r2c1": {
        this.emrservice.opto.dvwithGlassOd = row.popupDescription;
        
            break;
      }
      case "r2c2": {
        this.emrservice.opto.dvwithGlassOs = row.popupDescription;
        
            break;
      }
      case "r2c3": {
        this.emrservice.opto.nvwithGlassOd = row.popupDescription;
        
            break;
      }
      case "r2c4": {
        this.emrservice.opto.nvwithGlassOs = row.popupDescription;
        
            break;
      }
      case "r3c1": {
        this.emrservice.opto.dvpinholeOd = row.popupDescription;
        
            break;
      }
      case "r3c2": {
        this.emrservice.opto.dvpinholeOs = row.popupDescription;
        
            break;
      }
      case "r3c3": {
        this.emrservice.opto.nvpinholeOd = row.popupDescription;
        
            break;
      }
      case "r3c4": {
        this.emrservice.opto.nvpinholeOs = row.popupDescription;
        
            break;
      }
      case "r4c1": {
        this.emrservice.opto.dvbestCorrectOd = row.popupDescription;
        this.emrservice.opto.udrv1 =row.popupDescription;
        this.emrservice.enabledisableUd = false;
            break;
      }
      case "r4c2": {
        this.emrservice.opto.dvbestCorrectOs = row.popupDescription;
        this.emrservice.opto.udlv1 = row.popupDescription;
        this.emrservice.enabledisableUd = false;
            break;
      }
      case "r4c3": {
        this.emrservice.opto .nvbestCorrectOd= row.popupDescription;
        this.emrservice.opto.udnvr1 = row.popupDescription;
        this.emrservice.enabledisableUd = false;
      
            break;
      }
      case "r4c4": {
        this.emrservice.opto.nvbestCorrectOs = row.popupDescription;
        this.emrservice.opto.udnvl1 = row.popupDescription;
        this.emrservice.enabledisableUd = false;
        
            break;
      }
      case "r5c1": {
        this.emrservice.opto.dvclod = row.popupDescription;
        
            break;
      }
      case "r5c2": {
        this.emrservice.opto.dvclOs = row.popupDescription;
        
            break;
      }
      case "r5c3": {
        this.emrservice.opto.nvclod= row.popupDescription;
        
            break;
      }
      case "r5c4": {
        this.emrservice.opto.nvclos = row.popupDescription;
        
            break;
      }
    }
  }
  set_opto_udandd_values(row){
    switch (this.emrservice.ar_value_box) {
  
      // row 1
      case "r1c1_udr": {
  this.emrservice.opto.udrs1 = row.popupDescription;
  break ;
      }
      case "r1c2_udr": {
        this.emrservice.opto.udrc1 = row.popupDescription;
        break ;
      }
      case "r1c3_udr": {
        this.emrservice.opto.udra1 = row.popupDescription;
        break ;
      }
      case "r1c4_udr": {
        this.emrservice.opto.udrp1 = row.popupDescription;
        break ;
      }
      case "r1c5_udr": {
        this.emrservice.opto.udrv1 = row.popupDescription;
        break ;
      }
      case "r1c6_udr": {
        this.emrservice.opto.udnvr1 = row.popupDescription;
        break ;
      }
      case "r1c7_udr": {
        this.emrservice.opto.udls1 = row.popupDescription;
        break ;
      }
      case "r1c8_udr": {
        this.emrservice.opto.udlc1 = row.popupDescription;
        break ;
      }
      case "r1c9_udr": {
        this.emrservice.opto.udla1 = row.popupDescription;
        break ;
      }
      case "r1c10_udr": {
        this.emrservice.opto.udlp1 = row.popupDescription;
        break ;
      }
      case "r1c11_udr": {
        this.emrservice.opto.udlv1 = row.popupDescription;
        break ;
      }
      case "r1c12_udr": {
        this.emrservice.opto.udnvl1 = row.popupDescription;
        break ;
      }
  
       // row 2
  
       case "r2c1_udr": {
        this.emrservice.opto.udrs2 = row.popupDescription;
        break ;
            }
            case "r2_A_c1_udr": {
             
              let r2value: any = 0
              let r2avalue: any = 0
              r2value = parseFloat(row.popupDescription);
              if (this.emrservice.opto.udrs1 != '' && this.emrservice.opto.udrs1 != null) {
                r2avalue = parseFloat(this.emrservice.opto.udrs1);
                let totalvalue = r2value + r2avalue
                if(totalvalue.toFixed(2) >0){
                  this.emrservice.opto.udrs2 = '+'+ totalvalue.toFixed(2);
                }else{
                  this.emrservice.opto.udrs2= totalvalue.toFixed(2);
                }
                
              } else {
                this.emrservice.opto.udrs2 = row.popupDescription;
              }
              let r2value1: any = 0
              let r2avalue1: any = 0
              r2value1 = parseFloat(row.popupDescription);
              if (this.emrservice.opto.udls1 != '' && this.emrservice.opto.udls1 != null) {
                r2avalue1 = parseFloat(this.emrservice.opto.udls1);
                let totalvalue = r2value1 + r2avalue1
                if(totalvalue.toFixed(2) >0){
                  this.emrservice.opto.udls2 = '+'+ totalvalue.toFixed(2);
                }else{
                  this.emrservice.opto.udls2= totalvalue.toFixed(2);
                }
              }else{
                this.emrservice.opto.udls2 = row.popupDescription;
              }
              break;
             
              }
            case "r2c2_udr": {
              this.emrservice.opto.udrc2 = row.popupDescription;
              break ;
            }
            case "r2c3_udr": {
              this.emrservice.opto.udra2 = row.popupDescription;
              break ;
            }
            case "r2c4_udr": {
              this.emrservice.opto.udrp2 = row.popupDescription;
              break ;
            }
            case "r2c5_udr": {
              this.emrservice.opto.udrv2 = row.popupDescription;
              break ;
            }
            case "r2c6_udr": {
              //this.emrservice.opto.udnvr = row.popupDescription;
              break ;
            }
            case "r2c7_udr": {
              this.emrservice.opto.udls2 = row.popupDescription;
              break ;
            }
            case "r2c1_A_udr": {
             
              let r2value: any = 0
              let r2avalue: any = 0
              r2value = parseFloat(row.popupDescription);
              if (this.emrservice.opto.udls1 != '' && this.emrservice.opto.udls1 != null) {
                r2avalue = parseFloat(this.emrservice.opto.udls1);
                let totalvalue = r2value + r2avalue
                if(totalvalue.toFixed(2) >0){
                  this.emrservice.opto.udls2 = '+'+ totalvalue.toFixed(2);
                }else{
                  this.emrservice.opto.udls2= totalvalue.toFixed(2);
                }
                
              } else {
                this.emrservice.opto.udls2 = row.popupDescription;
              }
              break;
            }
            case "r2c8_udr": {
              this.emrservice.opto.udlc2 = row.popupDescription;
              break ;
            }
            case "r2c9_udr": {
              this.emrservice.opto.udla2 = row.popupDescription;
              break ;
            }
            case "r2c10_udr": {
              this.emrservice.opto.udlp2 = row.popupDescription;
              break ;
            }
            case "r2c11_udr": {
              this.emrservice.opto.udlv2 = row.popupDescription;
              break ;
            }
            case "r2c12_udr": {
            //  this.emrservice.opto.udnvl1 = row.popupDescription;
              break ;
            }
  
            // row 3
  
        
       case "r3c1_udr": {
        this.emrservice.opto.udrs3 = row.popupDescription;
        break ;
            }
            case "r3c2_udr": {
              this.emrservice.opto.udrc3 = row.popupDescription;
              break ;
            }
            case "r3c3_udr": {
              this.emrservice.opto.udra3 = row.popupDescription;
              break ;
            }
            case "r3c4_udr": {
              this.emrservice.opto.udrp3 = row.popupDescription;
              break ;
            }
            case "r3c5_udr": {
              this.emrservice.opto.udrv3 = row.popupDescription;
              break ;
            }
            case "r3c6_udr": {
              //this.emrservice.opto.udnvr = row.popupDescription;
              break ;
            }
            case "r3c7_udr": {
              this.emrservice.opto.udls3 = row.popupDescription;
              break ;
            }
            case "r3c8_udr": {
              this.emrservice.opto.udlc3 = row.popupDescription;
              break ;
            }
            case "r3c9_udr": {
              this.emrservice.opto.udla3 = row.popupDescription;
              break ;
            }
            case "r3c10_udr": {
              this.emrservice.opto.udlp3 = row.popupDescription;
              break ;
            }
            case "r3c11_udr": {
              this.emrservice.opto.udlv3 = row.popupDescription;
              break ;
            }
            case "r3c12_udr": {
            //  this.emrservice.opto.udnvl1 = row.popupDescription;
              break ;
            }
  
            // dilated row 1
  
            case "r1c1_dr": {
              this.emrservice.opto.drs1 = row.popupDescription;
              break ;
                  }
                  case "r1c2_dr": {
                    this.emrservice.opto.drc1 = row.popupDescription;
                    break ;
                  }
                  case "r1c3_dr": {
                    this.emrservice.opto.dra1 = row.popupDescription;
                    break ;
                  }
                  case "r1c4_dr": {
                  //  this.emrservice.opto.drp1 = row.popupDescription;
                    break ;
                  }
                  case "r1c5_dr": {
                    this.emrservice.opto.drv1 = row.popupDescription;
                    break ;
                  }
                  case "r1c6_dr": {
                   // this.emrservice.opto.dnvr1 = row.popupDescription;
                    break ;
                  }
                  case "r1c7_dr": {
                    this.emrservice.opto.dls1 = row.popupDescription;
                    break ;
                  }
                  case "r1c8_dr": {
                    this.emrservice.opto.dlc1 = row.popupDescription;
                    break ;
                  }
                  case "r1c9_dr": {
                    this.emrservice.opto.dla1 = row.popupDescription;
                    break ;
                  }
                  case "r1c10_dr": {
                  //  this.emrservice.opto.dlp1 = row.popupDescription;
                    break ;
                  }
                  case "r1c11_dr": {
                    this.emrservice.opto.dlv1 = row.popupDescription;
                    break ;
                  }
                  case "r1c12_dr": {
                    this.emrservice.opto.dlremarks = row.popupDescription;
                    break ;
                  }
              
  
    }
  }
  


set_ar_oldglass_values(row){
  switch (this.emrservice.ar_value_box) {

    // right eye
    case "r_og_r1_c1": {
      this.emrservice.autoref.odSph = row.popupDescription;
      
          break;
    }
    case "r_og_r1_c2": {
      this.emrservice.autoref.odCyl = row.popupDescription;
      
          break;
    }
    case "r_og_r1_c3": {
      this.emrservice.autoref.odAxis = row.popupDescription;
      
          break;
    }
    case "r_og_r1_c4": {
      this.emrservice.autoref.odDbscva = row.popupDescription;
      
          break;
    }
    case "r_og_r2_c1": {
      this.emrservice.autoref.odAdd = row.popupDescription;
      
          break;
    }
    case "r_og_r2_c2": {
      this.emrservice.autoref.odBscva = row.popupDescription;
      
          break;
    }

    //left eye
    case "l_og_r1_c1": {
      this.emrservice.autoref.osSph = row.popupDescription;
      
          break;
    }
    case "l_og_r1_c2": {
      this.emrservice.autoref.osCyl = row.popupDescription;
      
          break;
    }
    case "l_og_r1_c3": {
      this.emrservice.autoref.osAxis = row.popupDescription;
      
          break;
    }
    case "l_og_r1_c4": {
      this.emrservice.autoref.osDbscva = row.popupDescription;
      
          break;
    }
    case "l_og_r2_c1": {
      this.emrservice.autoref.osAdd = row.popupDescription;
      
          break;
    }
    case "l_og_r2_c2": {
      this.emrservice.autoref.osBscva = row.popupDescription;
      
          break;
    }
  }
}

set_opto_finalglass_student_values(row){
  switch (this.emrservice.ar_value_box) {
    // row 1 final glass
    case "r1c1_fg_student": {
      this.emrservice.students_opto.udrs1 = row.popupDescription;
      break ;
          }
    case "r1c2_fg_student": {
     this.emrservice.students_opto.udrc1 = row.popupDescription;
    break ;
    }
    case "r1c3_fg_student": {
    this.emrservice.students_opto.udra1 = row.popupDescription;
    break ;
    }
    case "r1c4_fg_student": {
      this.emrservice.students_opto.udrp1 = row.popupDescription;
       break ;
           }
     case "r1c5_fg_student": {
     this.emrservice.students_opto.udrv1 = row.popupDescription;
     break ;
     }
     case "r1c6_fg_student": {
    this.emrservice.students_opto.udnvr1 = row.popupDescription;
     break ;
     }
     case "r1c7_fg_student": {
       this.emrservice.students_opto.udls1 = row.popupDescription;
       break ;
           }
     case "r1c8_fg_student": {
     this.emrservice.students_opto.udlc1 = row.popupDescription;
     break ;
     }
     case "r1c9_fg_student": {
     this.emrservice.students_opto.udla1 = row.popupDescription;
     break ;
     }
     case "r1c10_fg_student": {
      this.emrservice.students_opto.udlp1 = row.popupDescription;
       break ;
           }
     case "r1c11_fg_student": {
      this.emrservice.students_opto.udlv1 = row.popupDescription;
     break ;
     }
     case "r1c12_fg_student": {
     this.emrservice.students_opto.udnvl1 = row.popupDescription;
     break ;
     }

     // row 2
    case "r2c1_A_student": {
      let r2value: any = 0
      let r2avalue: any = 0
      r2value = parseFloat(row.popupDescription);
      if (this.emrservice.students_opto.udrs1 != '' && this.emrservice.students_opto.udrs1 != null) {
        r2avalue = parseFloat(this.emrservice.students_opto.udrs1);
        let totalvalue = r2value + r2avalue
        this.emrservice.students_opto.udrs2 = totalvalue.toFixed(2);
      } else {
        this.emrservice.students_opto.udrs2 = row.popupDescription;
      }
      break;
    }
    case "l2c1_A_student": {
      let r2value: any = 0
      let r2avalue: any = 0
      r2value = parseFloat(row.popupDescription);
      if (this.emrservice.students_opto.udls1 != '' && this.emrservice.students_opto.udls1 != null) {
        r2avalue = parseFloat(this.emrservice.students_opto.udls1);
        let totalvalue = r2value + r2avalue
        this.emrservice.students_opto.udls2 = totalvalue.toFixed(2);
      } else {
        this.emrservice.students_opto.udls2 = row.popupDescription;
      }
      break;
    }
     case "r2c1_fg_student": {
      this.emrservice.students_opto.udrs2 = row.popupDescription;
      break ;
          }
    case "r2c2_fg_student": {
     this.emrservice.students_opto.udrc2 = row.popupDescription;
    break ;
    }
    case "r2c3_fg_student": {
    this.emrservice.students_opto.udra2 = row.popupDescription;
    break ;
    }
    case "r2c4_fg_student": {
      this.emrservice.students_opto.udrp2 = row.popupDescription;
       break ;
           }
     case "r2c5_fg_student": {
     this.emrservice.students_opto.udrv2 = row.popupDescription;
     break ;
     }
     case "r2c6_fg_student": {
    //this.emrservice.opto.gpnvrn = row.popupDescription;
     break ;
     }//r2c7_fg_student
     case "r2c7_fg_student": {
       console.log("r2c7 value ");
       this.emrservice.students_opto.udls2 = row.popupDescription;
       break ;
           }
     case "r2c8_fg_student": {
     this.emrservice.students_opto.udlc2 = row.popupDescription;
     break ;
     }
     case "r2c9_fg_student": {
     this.emrservice.students_opto.udla2 = row.popupDescription;
     break ;
     }
     case "r2c10_fg_student": {
      this.emrservice.students_opto.udlp2 = row.popupDescription;
       break ;
           }
     case "r2c11_fg_student": {
      this.emrservice.students_opto.udlv2 = row.popupDescription;
     break ;
     }
     case "r2c12_fg_student": {
     //this.emrservice.opto.gpnvln = row.popupDescription;
     break ;
     }

// row 3

case "r3c1_fg_student": {
  this.emrservice.students_opto.udrs3 = row.popupDescription;
  break ;
      }
case "r3c2_fg_student": {
 this.emrservice.students_opto.udrc3 = row.popupDescription;
break ;
}
case "r3c3_fg_student": {
this.emrservice.students_opto.udra3 = row.popupDescription;
break ;
}
case "r3c4_fg_student": {
  this.emrservice.students_opto.udrp3 = row.popupDescription;
   break ;
       }
 case "r3c5_fg_student": {
 this.emrservice.students_opto.udrv3 = row.popupDescription;
 break ;
 }
 case "r3c6_fg_student": {
//this.emrservice.opto.gpnvrn = row.popupDescription;
 break ;
 }
 case "r3c7_fg_student": {
   this.emrservice.students_opto.udls3 = row.popupDescription;
   break ;
       }
 case "r3c8_fg_student": {
 this.emrservice.students_opto.udlc3 = row.popupDescription;
 break ;
 }
 case "r3c9_fg_student": {
 this.emrservice.students_opto.udla3 = row.popupDescription;
 break ;
 }
 case "r3c10_fg_student": {
  this.emrservice.students_opto.udlp3 = row.popupDescription;
   break ;
       }
 case "r3c11_fg_student": {
  this.emrservice.students_opto.udlv3 = row.popupDescription;
 break ;
 }
 case "r3c12_fg_student": {
 //this.emrservice.opto.gpnvln = row.popupDescription;
 break ;
 }
  }
 }
   
 
 set_opto_finalglass_values(row){
  switch (this.emrservice.ar_value_box) {
    // row 1 final glass
    case "r1c1_fg": {
      this.emrservice.opto.gprsd = row.popupDescription;
      break ;
          }
    case "r1c2_fg": {
     this.emrservice.opto.gprcd = row.popupDescription;
    break ;
    }
    case "r1c3_fg": {
    this.emrservice.opto.gprad = row.popupDescription;
    break ;
    }
    case "r1c4_fg": {
      this.emrservice.opto.gprpd = row.popupDescription;
       break ;
           }
     case "r1c5_fg": {
     this.emrservice.opto.gprvd = row.popupDescription;
     break ;
     }
     case "r1c6_fg": {
    this.emrservice.opto.gpnvr1 = row.popupDescription;
     break ;
     }
     case "r1c7_fg": {
       this.emrservice.opto.gplsd = row.popupDescription;
       break ;
           }
     case "r1c8_fg": {
     this.emrservice.opto.gplcd = row.popupDescription;
     break ;
     }
     case "r1c9_fg": {
     this.emrservice.opto.gplad = row.popupDescription;
     break ;
     }
     case "r1c10_fg": {
      this.emrservice.opto.gplps = row.popupDescription;
       break ;
           }
     case "r1c11_fg": {
      this.emrservice.opto.gplvd = row.popupDescription;
     break ;
     }
     case "r1c12_fg": {
     this.emrservice.opto.gpnvl1 = row.popupDescription;
     break ;
     }

     // row 2
     case "r2c1_fg": {
      this.emrservice.opto.gprsn = row.popupDescription;
      break ;
          }
    case "r2c2_fg": {
     this.emrservice.opto.gprcn = row.popupDescription;
    break ;
    }
    case "r2c3_fg": {
    this.emrservice.opto.gpran = row.popupDescription;
    break ;
    }
    case "r2c4_fg": {
      this.emrservice.opto.gprpn = row.popupDescription;
       break ;
           }
     case "r2c5_fg": {
     this.emrservice.opto.gprvn = row.popupDescription;
     break ;
     }
     case "r2c6_fg": {
    //this.emrservice.opto.gpnvrn = row.popupDescription;
     break ;
     }
     case "r2c7_fg": {
       this.emrservice.opto.gplsn = row.popupDescription;
       break ;
           }
     case "r2c8_fg": {
     this.emrservice.opto.gplcn = row.popupDescription;
     break ;
     }
     case "r2c9_fg": {
     this.emrservice.opto.gplan = row.popupDescription;
     break ;
     }
     case "r2c10_fg": {
      this.emrservice.opto.gplpn = row.popupDescription;
       break ;
           }
     case "r2c11_fg": {
      this.emrservice.opto.gplvn = row.popupDescription;
     break ;
     }
     case "r2c12_fg": {
     //this.emrservice.opto.gpnvln = row.popupDescription;
     break ;
     }

// row 3

case "r3c1_fg": {
  this.emrservice.opto.gprsI = row.popupDescription;
  break ;
      }
case "r3c2_fg": {
 this.emrservice.opto.gprcI = row.popupDescription;
break ;
}
case "r3c3_fg": {
this.emrservice.opto.gpraI = row.popupDescription;
break ;
}
case "r3c4_fg": {
  this.emrservice.opto.gprpI = row.popupDescription;
   break ;
       }
 case "r3c5_fg": {
 this.emrservice.opto.gprvI = row.popupDescription;
 break ;
 }
 case "r3c6_fg": {
//this.emrservice.opto.gpnvrn = row.popupDescription;
 break ;
 }
 case "r3c7_fg": {
   this.emrservice.opto.gplsI = row.popupDescription;
   break ;
       }
 case "r3c8_fg": {
 this.emrservice.opto.gplcI = row.popupDescription;
 break ;
 }
 case "r3c9_fg": {
 this.emrservice.opto.gplaI = row.popupDescription;
 break ;
 }
 case "r3c10_fg": {
  this.emrservice.opto.gplpI = row.popupDescription;
   break ;
       }
 case "r3c11_fg": {
  this.emrservice.opto.gplvI = row.popupDescription;
 break ;
 }
 case "r3c12_fg": {
 //this.emrservice.opto.gpnvln = row.popupDescription;
 break ;
 }
  }
 }

 set_opto_student_values(row){
  switch (this.emrservice.ar_value_box) {
    // row 1 student opto
    case "student_r1c1": {
      this.emrservice.students_opto.dvunaidedOd = row.popupDescription;
      break ;
          }
    case "student_r1c2": {
            this.emrservice.students_opto.dvunaidedOs = row.popupDescription;
            break ;
                } 
    case "student_r1c3": {
                  this.emrservice.students_opto.vunaidedOd = row.popupDescription;
                  break ;
                      }  
    case "student_r1c4": {
                        this.emrservice.students_opto.vunaidedOs = row.popupDescription;
                        break ;
                            }    
     // row 2 student opto
     case "student_r2c1": {
      this.emrservice.students_opto.dvwithGlassOd = row.popupDescription;
      break ;
          }
    case "student_r2c2": {
            this.emrservice.students_opto.dvwithGlassOs = row.popupDescription;
            break ;
                } 
    case "student_r2c3": {
                  this.emrservice.students_opto.vwithGlassOd = row.popupDescription;
                  break ;
                      }  
    case "student_r2c4": {
                        this.emrservice.students_opto.vwithGlassOs = row.popupDescription;
                        break ;
                            }    
     // row 3 student opto
     case "student_r3c1": {
      this.emrservice.students_opto.dvpinholeOd = row.popupDescription;
      break ;
          }
    case "student_r3c2": {
            this.emrservice.students_opto.dvpinholeOs = row.popupDescription;
            break ;
                } 
    case "student_r3c3": {
                  this.emrservice.students_opto.vpinholeOd = row.popupDescription;
                  break ;
                      }  
    case "student_r3c4": {
                        this.emrservice.students_opto.vpinholeOs = row.popupDescription;
                        break ;
                            }     
     // row 4 student opto
     case "student_r4c1": {
      this.emrservice.students_opto.dbestCorrectOd = row.popupDescription;
      break ;
          }
    case "student_r4c2": {
            this.emrservice.students_opto.dbestCorrectOs = row.popupDescription;
            break ;
                } 
    case "student_r4c3": {
                  this.emrservice.students_opto.bestCorrectOd = row.popupDescription;
                  break ;
                      }  
    case "student_r4c4": {
                        this.emrservice.students_opto.bestCorrectOs = row.popupDescription;
                        break ;
                            }                                                                                      
        }
 }
  selectrow(row) {
   
    // set opto vision 
    this.set_opto_vison_values(row);
    this.set_opto_udandd_values(row);
    this.set_opto_finalglass_values(row);
    this.set_ar_oldglass_values(row);
    this.set_opto_student_values(row);
    this.set_opto_finalglass_student_values(row);
    this.set_kmr_values(row);
    //console.log ("box value " + this.emrservice.ar_value_box);

    // undilated right eye
    switch (this.emrservice.ar_value_box) {
      case "u_r_r1_c1": {
        this.emrservice.autoref.rs1 = row.popupDescription;
        
            break;
      }
      case "u_r_r1_c2": {
        this.emrservice.autoref.rc1 = row.popupDescription;
        
            break;
      }
      case "u_r_r1_c3": {
        this.emrservice.autoref.ra1 = row.popupDescription;
        
            break;
      }
      case "u_r_r2_c1": {
        this.emrservice.autoref.rs2 = row.popupDescription;
        
            break;
      }
      case "u_r_r2_c2": {
        this.emrservice.autoref.rc2 = row.popupDescription;
        
            break;
      }
      case "u_r_r2_c3": {
        this.emrservice.autoref.ra2 = row.popupDescription;
        
            break;
      }
      case "u_r_r3_c1": {
        this.emrservice.autoref.rs3 = row.popupDescription;
        
            break;
      }
      case "u_r_r5_c1": {
        this.emrservice.autoref.rs5 = row.popupDescription;
        
            break;
      }
      case "u_r_r5_c2": {
        this.emrservice.autoref.rc5 = row.popupDescription;
        
            break;
      }
      case "u_l_r5_c1": {
        this.emrservice.autoref.ls5 = row.popupDescription;
        
            break;
      } case "u_l_r5_c2": {
        this.emrservice.autoref.lc5 = row.popupDescription;
        
            break;
      }
      case "u_r_r3_c2": {
        this.emrservice.autoref.rc3 = row.popupDescription;
        
            break;
      }
      case "u_r_r3_c3": {
        this.emrservice.autoref.ra3 = row.popupDescription;
        
            break;
      }
      case "u_r_r4_c1": {
        this.emrservice.autoref.udrs = row.popupDescription;
        
            break;
      }
      case "u_r_r4_c2": {
        this.emrservice.autoref.udrc = row.popupDescription;
        
            break;
      }
      case "u_r_r4_c3": {
        this.emrservice.autoref.udra = row.popupDescription;
        
            break;
      }

      // undilated left eye

      case "u_l_r1_c1": {
        this.emrservice.autoref.ls1 = row.popupDescription;
        
            break;
      }
      case "u_l_r1_c2": {
        this.emrservice.autoref.lc1 = row.popupDescription;
        
            break;
      }
      case "u_l_r1_c3": {
        this.emrservice.autoref.la1 = row.popupDescription;
        
            break;
      }
      case "u_l_r2_c1": {
        this.emrservice.autoref.ls2 = row.popupDescription;
        
            break;
      }
      case "u_l_r2_c2": {
        this.emrservice.autoref.lc2 = row.popupDescription;
        
            break;
      }
      case "u_l_r2_c3": {
        this.emrservice.autoref.la2 = row.popupDescription;
        
            break;
      }
      case "u_l_r3_c1": {
        this.emrservice.autoref.ls3 = row.popupDescription;
        
            break;
      }
      case "u_l_r3_c2": {
        this.emrservice.autoref.lc3 = row.popupDescription;
        
            break;
      }
      case "u_l_r3_c3": {
        this.emrservice.autoref.la3 = row.popupDescription;
        
            break;
      }
      case "u_l_r4_c1": {
        this.emrservice.autoref.udls = row.popupDescription;
        
            break;
      }
      case "u_l_r4_c2": {
        this.emrservice.autoref.udlc = row.popupDescription;
        
            break;
      }
      case "u_l_r4_c3": {
        this.emrservice.autoref.udla = row.popupDescription;
        
            break;
      }

      // dialated right

      case "d_r_r1_c1": {
        this.emrservice.autoref.drs1 = row.popupDescription;
        
            break;
      }
      case "d_r_r1_c2": {
        this.emrservice.autoref.drc1 = row.popupDescription;
        
            break;
      }
      case "d_r_r1_c3": {
        this.emrservice.autoref.dra1 = row.popupDescription;
        
            break;
      }
      case "d_r_r2_c1": {
        this.emrservice.autoref.drs2 = row.popupDescription;
        
            break;
      }
      case "d_r_r2_c2": {
        this.emrservice.autoref.drc2 = row.popupDescription;
        
            break;
      }
      case "d_r_r2_c3": {
        this.emrservice.autoref.dra2 = row.popupDescription;
        
            break;
      }
      case "d_r_r3_c1": {
        this.emrservice.autoref.drs3 = row.popupDescription;
        
            break;
      }
      case "d_r_r3_c2": {
        this.emrservice.autoref.drc3 = row.popupDescription;
        
            break;
      }
      case "d_r_r3_c3": {
        this.emrservice.autoref.dra3 = row.popupDescription;
        
            break;
      }
      case "d_r_r4_c1": {
        this.emrservice.autoref.drs = row.popupDescription;
        
            break;
      }
      case "d_r_r4_c2": {
        this.emrservice.autoref.drc = row.popupDescription;
        
            break;
      }
      case "d_r_r4_c3": {
        this.emrservice.autoref.dra = row.popupDescription;
        
            break;
      }

      // dilated left eye
      case "d_l_r1_c1": {
        this.emrservice.autoref.dls1 = row.popupDescription;
        
            break;
      }
      case "d_l_r1_c2": {
        this.emrservice.autoref.dlc1 = row.popupDescription;
        
            break;
      }
      case "d_l_r1_c3": {
        this.emrservice.autoref.dla1 = row.popupDescription;
        
            break;
      }
      case "d_l_r2_c1": {
        this.emrservice.autoref.dls2 = row.popupDescription;
        
            break;
      }
      case "d_l_r2_c2": {
        this.emrservice.autoref.dlc2 = row.popupDescription;
        
            break;
      }
      case "d_l_r2_c3": {
        this.emrservice.autoref.dla2 = row.popupDescription;
        
            break;
      }
      case "d_l_r3_c1": {
        this.emrservice.autoref.dls3 = row.popupDescription;
        
            break;
      }
      case "d_l_r3_c2": {
        this.emrservice.autoref.dlc3 = row.popupDescription;
        
            break;
      }
      case "d_l_r3_c3": {
        this.emrservice.autoref.dla3 = row.popupDescription;
        
            break;
      }
      case "d_l_r4_c1": {
        this.emrservice.autoref.dls = row.popupDescription;
        
            break;
      }
      case "d_l_r4_c2": {
        this.emrservice.autoref.dlc = row.popupDescription;
        
            break;
      }
      case "d_l_r4_c3": {
        this.emrservice.autoref.dla = row.popupDescription;
        
            break;
      }
      case "d_r_r5_c1": {
        this.emrservice.autoref.drs5 = row.popupDescription;
        
            break;
      }
      case "d_r_r5_c2": {
        this.emrservice.autoref.drc5 = row.popupDescription;
        
            break;
      }
      case "d_l_r5_c1": {
        this.emrservice.autoref.dls5 = row.popupDescription;
        
            break;
      }
      case "d_l_r5_c2": {
        this.emrservice.autoref.dlc5 = row.popupDescription;
        
            break;
      }
    }

    this.emrservice.ar_value_box = null;
   

   // this.emrservice.autoref.dexamCyl= row.popupDescription;
   this.dialogRef.close(row);
    //console.log("row id: " + row.sequence)
   // this.dashboardService.selectedRowIndex = row.pkDiseaseId;
    //this.emrservice.pasthistory_added.diseaseName = row.diseaseName;
  }

  set_kmr_values(row) {
    switch (this.emrservice.keratometer_value_box) {
      //Dilated row - 1
      case "d_kr_r1_p1": {
        this.emrservice.autoref.kmrp1 = row.popupDescription;
        break;
      }
      case "d_kr_r1_r1": {
        this.emrservice.autoref.kmrr1 = row.popupDescription;
        break;
      }
      case "d_kr_r1_a1": {
        this.emrservice.autoref.kmra1 = row.popupDescription;
        break;
      }
      // row - 2
      case "d_kr_r2_p2": {
        this.emrservice.autoref.kmrp2 = row.popupDescription;
        break;
      }
      case "d_kr_r2_r2": {
        this.emrservice.autoref.kmrr2 = row.popupDescription;
        break;
      }
      case "d_kr_r2_a2": {
        this.emrservice.autoref.kmra2 = row.popupDescription;
        break;
      }

      // row - 3
      case "d_kr_r3_a3": {
        this.emrservice.autoref.kmra3 = row.popupDescription;
        break;
      }
      case "d_kr_r3_r3": {
        this.emrservice.autoref.kmrr3 = row.popupDescription;
        break;
      }
      case "d_kr_r3_p3": {
        this.emrservice.autoref.kmrp3 = row.popupDescription;
        break;
      }
      // row - 4
      case "d_kr_r4_p4": {
        this.emrservice.autoref.kmrp4 = row.popupDescription;
        break;
      }
      case "d_kr_r4_r4": {
        this.emrservice.autoref.kmrr4 = row.popupDescription;
        break;
      }
      case "d_kr_r4_a4": {
        this.emrservice.autoref.kmra4 = row.popupDescription;
        break;
      }
      // row - 5
      case "d_kr_r5_p5": {
        this.emrservice.autoref.kmrp5 = row.popupDescription;
        break;
      }
      case "d_kr_r5_r5": {
        this.emrservice.autoref.kmrr5 = row.popupDescription;
        break;
      }
      case "d_kr_r5_a5": {
        this.emrservice.autoref.kmra5 = row.popupDescription;
        break;
      }

      // row - 1
      case "d_kr_l1_p1": {
        this.emrservice.autoref.kmlp1 = row.popupDescription;
        break;
      }
      case "d_kr_l1_r1": {
        this.emrservice.autoref.kmlr1 = row.popupDescription;
        break;
      }
      case "d_kr_l1_a1": {
        this.emrservice.autoref.kmla1 = row.popupDescription;
        break;
      }
      // row - 2
      case "d_kr_l2_p2": {
        this.emrservice.autoref.kmlp2 = row.popupDescription;
        break;
      }
      case "d_kr_l2_r2": {
        this.emrservice.autoref.kmlr2 = row.popupDescription;
        break;
      }
      case "d_kr_l2_a2": {
        this.emrservice.autoref.kmla2 = row.popupDescription;
        break;
      }
      // row - 3
      case "d_kr_l3_p3": {
        this.emrservice.autoref.kmlp3 = row.popupDescription;
        break;
      }
      case "d_kr_l3_r3": {
        this.emrservice.autoref.kmlr3 = row.popupDescription;
        break;
      }
      case "d_kr_l3_a3": {
        this.emrservice.autoref.kmla3 = row.popupDescription;
        break;
      }

      // row - 4
      case "d_kr_l4_p4": {
        this.emrservice.autoref.kmlp4 = row.popupDescription;
        break;
      }
      case "d_kr_l4_r4": {
        this.emrservice.autoref.kmlr4 = row.popupDescription;
        break;
      }
      case "d_kr_l4_a4": {
        this.emrservice.autoref.kmla4 = row.popupDescription;
        break;
      }

      // row - 5
      case "d_kr_l5_p5": {
        this.emrservice.autoref.kmlp5 = row.popupDescription;
        break;
      }
      case "d_kr_l5_r5": {
        this.emrservice.autoref.kmlr5 = row.popupDescription;
        break;
      }
      case "d_kr_l5_a5": {
        this.emrservice.autoref.kmla5 = row.popupDescription;
        break;
      }


      //Undilated
      case "un_kr_r1_p1": {
        this.emrservice.autoref.dkmrp1 = row.popupDescription;
        break;
      }
      case "un_kr_r1_r1": {
        this.emrservice.autoref.dkmrr1 = row.popupDescription;
        break;
      }
      case "un_kr_r1_a1": {
        this.emrservice.autoref.dkmra1 = row.popupDescription;
        break;
      }


      case "un_kr_r2_p2": {
        this.emrservice.autoref.dkmrp2 = row.popupDescription;
        break;
      }
      case "un_kr_r2_r2": {
        this.emrservice.autoref.dkmrr2 = row.popupDescription;
        break;
      }
      case "un_kr_r2_a2": {
        this.emrservice.autoref.dkmra2 = row.popupDescription;
        break;
      }

      case "un_kr_r3_p3": {
        this.emrservice.autoref.dkmrp3 = row.popupDescription;
        break;
      }
      case "un_kr_r3_r3": {
        this.emrservice.autoref.dkmrr3 = row.popupDescription;
        break;
      }
      case "un_kr_r3_a3": {
        this.emrservice.autoref.dkmra3 = row.popupDescription;
        break;
      }


      case "un_kr_r4_p4": {
        this.emrservice.autoref.dkmrp4 = row.popupDescription;
        break;
      }
      case "un_kr_r4_r4": {
        this.emrservice.autoref.dkmrr4 = row.popupDescription;
        break;
      }
      case "un_kr_r4_a4": {
        this.emrservice.autoref.dkmra4 = row.popupDescription;
        break;
      }


      case "un_kr_r5_p5": {
        this.emrservice.autoref.dkmrp5 = row.popupDescription;
        break;
      }
      case "un_kr_r5_r5": {
        this.emrservice.autoref.dkmrr5 = row.popupDescription;
        break;
      }
      case "un_kr_r5_a5": {
        this.emrservice.autoref.dkmra5 = row.popupDescription;
        break;
      }


      case "un_kr_l1_p1": {
        this.emrservice.autoref.dkmlp1 = row.popupDescription;
        break;
      }
      case "un_kr_l1_r1": {
        this.emrservice.autoref.dkmlr1 = row.popupDescription;
        break;
      }
      case "un_kr_l1_a1": {
        this.emrservice.autoref.dkmla1 = row.popupDescription;
        break;
      }

      case "un_kr_l2_p2": {
        this.emrservice.autoref.dkmlp2 = row.popupDescription;
        break;
      }
      case "un_kr_l2_r2": {
        this.emrservice.autoref.dkmlr2 = row.popupDescription;
        break;
      }
      case "un_kr_l2_a2": {
        this.emrservice.autoref.dkmla2 = row.popupDescription;
        break;
      }

      case "un_kr_l3_p3": {
        this.emrservice.autoref.dkmlp3 = row.popupDescription;
        break;
      }
      case "un_kr_l3_r3": {
        this.emrservice.autoref.dkmlr3 = row.popupDescription;
        break;
      }
      case "un_kr_l3_a3": {
        this.emrservice.autoref.dkmla3 = row.popupDescription;
        break;
      }

      case "un_kr_l4_p4": {
        this.emrservice.autoref.dkmlp4 = row.popupDescription;
        break;
      }
      case "un_kr_l4_r4": {
        this.emrservice.autoref.dkmlr4 = row.popupDescription;
        break;
      }
      case "un_kr_l4_a4": {
        this.emrservice.autoref.dkmla4 = row.popupDescription;
        break;
      }

      case "un_kr_l5_p5": {
        this.emrservice.autoref.dkmlp5 = row.popupDescription;
        break;
      }
      case "un_kr_l5_r5": {
        this.emrservice.autoref.dkmlr5 = row.popupDescription;
        break;
      }
      case "un_kr_l5_a5": {
        this.emrservice.autoref.dkmla5 = row.popupDescription;
        break;
      }
    }
    this.emrservice.keratometer_value_box = null;
  }
  constructor(public dialog: MatDialog,
    public emrservice: EMRService,
    public helplistservice: HelplistService,public dialogRef: MatDialogRef<EyecheckComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
      dialogRef.disableClose = true;
    }

  ngOnInit() {
    if(this.emrservice.eyechkcategory == "ar") {
      // alert("ar");
      let countries;
      countries = this.helplistservice.eyevisiontypes_SPH.slice();
       this.plusValues = countries.filter((country) => country.popupDescription.startsWith("+"));
       this.minusValues = countries.filter((country) => country.popupDescription.startsWith("-"));
       console.log(this.plusValues);
      
      // this.dataSource.data = this.helplistservice.eyevisiontypes_SPH.slice();
    }
    else if (this.emrservice.eyechkcategory == "opt"){
      // alert("opt");
      this.dataSource.data = this.helplistservice.eyevisiontypes_CYL.slice();
    }
    else if (this.emrservice.eyechkcategory == "axs"){
      this.dataSource.data = this.helplistservice.eyevisiontypes_AXS.slice();
    }
else if (this.emrservice.eyechkcategory == "VA"){
      this.dataSource.data = this.helplistservice.eyevisiontypes_VA.slice();
    }
    

  }

  closedialog() {

    this.dialogRef.close();

  }
}
